// Вход в приложение: обмен initData (или dev-пользователя) на пару токенов.
//
// Живёт в `shared/api`, а не в слайсе: токены — инфраструктура транспорта, ими пользуется
// `httpClient` для заголовка Authorization и для refresh. Домена здесь нет.

import { API_PATHS, type AuthTelegramResponse } from '@lunya/contracts'

import { DEV_USER_ID, USE_MOCKS } from '~/shared/config'

import { httpRequest } from './http/httpClient'
import { tokenStorage } from './http/tokenStorage'

export type AuthenticateInput = {
  /** initData из Telegram WebApp. В браузере его нет. */
  initData: string | null
}

export type AuthenticateResult = {
  /**
   * Пользователь создан этим запросом. Статус онбординга по нему НЕ определяется: признак
   * живёт на сервере в `onboarded_at` (`GET /users/me`), а `is_new` говорит лишь о том,
   * что аккаунт завели прямо сейчас.
   */
  isNew: boolean
}

/**
 * Аутентифицирует пользователя и складывает токены в хранилище.
 *
 * В Telegram уходит `init_data`, в браузере — `dev_user_id`. Второй путь работает только
 * если бэкенд поднят с `AUTH_DEV_BYPASS=true` и не в проде (docs/backend.md §4): именно он
 * позволяет открыть приложение с настоящим бэкендом без Telegram.
 */
export async function authenticate(input: AuthenticateInput): Promise<AuthenticateResult> {
  if (USE_MOCKS) {
    // На моках сети нет вовсе — считаем, что вход уже состоялся.
    return { isNew: false }
  }

  const body = input.initData ? { init_data: input.initData } : { dev_user_id: DEV_USER_ID }

  const response = await httpRequest<AuthTelegramResponse, typeof body>({
    path: API_PATHS.auth.telegram,
    method: 'POST',
    input: body,
  })

  tokenStorage.setTokens({
    accessToken: response.access_token,
    refreshToken: response.refresh_token,
  })

  return { isNew: response.is_new }
}

/** Есть ли уже действующая сессия (токен от прошлого запуска). */
export function hasSession(): boolean {
  return tokenStorage.getAccessToken() !== null
}

/** Выход: чистим токены. Профиль на сервере не трогаем. */
export function signOut(): void {
  tokenStorage.clearTokens()
}
